<style lang="css" scoped>

.input {
    padding-left: 2%;
    padding-right: 5%;
    max-width: 300px;
}

.badge {
    padding: 2%;
    margin-left: 1%;
    margin-right: 1%;
    margin-top: 1%;
}

.card-header {
    color: white;
    background-color: #2a2a2e;
}

button {
    padding-left: 8%;
    padding-right: 8%;
}

.main {
    width: 100%;
    height: 100%;
}

.prog-container {
    overflow-y: auto;
}

#card {}

.card-header {
    text-align: left;
}

</style>

<template>
<div class="main">
    <v-simple-table>
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">
                        Name
                    </th>
                    <th class="text-left">
                        Username
                    </th>
                    <th class="text-center">
                        Roles
                    </th>
                    <th class="text-left">
                        Locations
                    </th>
                    <th class="text-left">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>

                <tr v-for="item in items" :key="item.email">
                  <td>{{item.fname +" "+ item.lname}}</td>
                  <td>{{ item.username }}</td>
                  <td><b-button v-for="role in roles"  size='sm' class="badge" :variant="check(item,role.role)" @click="badge(item,role.role)">{{role.role}}</b-button></td>
                  <td><b-button v-for="loc in locations" size='sm' class="badge" style="padding:3%" :variant="checkL(item,loc.id)" @click="badgeL(item,loc)" >{{loc.name}}</b-button></td>
                  <td>
                    <b-button size='sm' variant="success" @click="update(item)">Update</b-button>
                  </td>

                </tr>

            </tbody>
        </template>
    </v-simple-table>


</div>

</template>

<script>

export default {
    created() {
            this.$overlay.show(this);
            this.$api.getRoles().then((response) => {
                if (response.status == 200) {
                    this.roles = response.data;
                }
            }).catch(error => {
                this.$toasted.error("Error connecting to server").goAway(1500);
            });

            this.$api.getLocations().then((response) => {
                if (response.status == 200) {
                    this.locations = response.data
                }
            }).catch(error => {
                this.$toasted.error("Error connecting to server").goAway(1500);
            })

            this.$api.getUsers().then((response) => {
                if (response.status == 200) {
                    this.items = response.data
                }
                this.$overlay.hide();
            }).catch(error => {
                this.$toasted.error("Error connecting to server").goAway(1500);
                this.$overlay.hide();
            })

        },
        data: () => ({
            locations: [],
            roles: [],
            fields: [{
                key: 'name',
                label: "Name"
            }, {
                key: 'username',
                label: 'Username'
            }, {
                key: 'email',
                label: 'Email'
            }, {
                key: 'roles',
                label: 'Roles'
            }, {
                key: 'locations',
                label: 'Locations'
            }, {
                key: 'actions',
                label: "Actions"
            }],
            items: [

            ]

        }),
        methods: {
            badge(item, role) {
                    let x = this.exists(item.roles, role)
                    if (x >= 0) {
                        item.roles.splice(x, 1);
                    } else {
                        item.roles.push({
                            'role': role
                        });
                    }
                },
                update(item) {
                    this.$overlay.show(this);
                    this.$api.updateUser(item).then((response) => {
                        if (response.status == 202) {
                            this.$toasted.success("User roles updated.").goAway(1200);
                        }
                        this.$overlay.hide();
                    }).catch(error => {
                        this.$toasted.error("Error connecting to server").goAway(1500);
                        this.$overlay.hide();
                    });
                },
                check(item, role) {
                    var s = "secondary"
                    for (var i = 0; i < item.roles.length; i++) {
                        if (item.roles[i].role.localeCompare(role) == 0) {
                            s = "success"
                        }
                    }
                    return s;
                },
                exists(roles, role) {
                    var s = -1;
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].role.localeCompare(role) == 0) {
                            s = i;
                        }
                    }
                    return s;
                },
                badgeL(item, loc) {
                    let x = this.existsL(item.locations, loc.id)
                    if (x >= 0) {
                        item.locations.splice(x, 1);
                    } else {
                        item.locations.push(loc);
                    }
                },
                checkL(item, loc) {
                    var s = "secondary"
                    for (var i = 0; i < item.locations.length; i++) {
                        if (item.locations[i].id == loc) {
                            s = "success"
                        }
                    }
                    return s;
                },
                existsL(roles, loc) {
                    var s = -1;
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].id == loc) {
                            s = i;
                        }
                    }
                    return s;
                },
        }
}

</script>
